export default __webpack_public_path__ + "static/media/GmcBg.7d363d19.svg";